var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container vh-100"},[_c('div',{staticClass:"row align-items-center justify-content-center vh-100"},[_c('div',{staticClass:"card col-md-4 mt-5 bg-secondary text-light rounded"},[_c('div',{staticClass:"card-body"},[_c('p',[_vm._v("Аутентификация...")]),_c('p',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.error))])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }